import * as types from '../types';
import { cacheTimeouts } from '../../helpers/constants';

const INITIAL_STATE = {
  payMethods: 0,
  payWay: {},
  payMethodPayWays: {},
  warning: {},
  description: {},
  manual: {},
};

function getCacheExpiration(type) {
  return Date.now() + cacheTimeouts[type] * 1000;
}

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.PAY_METHODS_FETCHED: {
      return {
        ...state,
        payMethods: getCacheExpiration('payMethods'),
      };
    }
    case types.PAY_WAYS_FOR_PAY_METHOD_FETCHED: {
      const { id } = action.payload;

      return {
        ...state,
        payMethodPayWays: {
          ...state.payMethodPayWays,
          [id]: getCacheExpiration('payMethodPayWays'),
        },
      };
    }
    case types.PAY_WAY_FETCHED: {
      const { id } = action.payload;

      return {
        ...state,
        payWay: {
          ...state.payWay,
          [id]: getCacheExpiration('payWay'),
        },
      };
    }
    case types.WARNING_FETCHED: {
      const { id, lang } = action.payload;

      return {
        ...state,
        warning: {
          ...state.warning,
          [id]: {
            ...(state.warning[id] || {}),
            [lang]: getCacheExpiration('warning'),
          },
        },
      };
    }
    case types.DESCRIPTION_FETCHED: {
      const { id, lang } = action.payload;

      return {
        ...state,
        description: {
          ...state.description,
          [id]: {
            ...(state.description[id] || {}),
            [lang]: getCacheExpiration('description'),
          },
        },
      };
    }
    case types.MANUAL_FETCHED: {
      const { id, lang } = action.payload;

      return {
        ...state,
        manual: {
          ...state.manual,
          [id]: {
            ...(state.manual[id] || {}),
            [lang]: getCacheExpiration('manual'),
          },
        },
      };
    }
    default:
      return state;
  }
}
